import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Switch from 'react-switch';

import Label from '../../../../../Label';

const propTypes = {
  className: PropTypes.string,
  gridEnabled: PropTypes.bool.isRequired,
  setGridEnabled: PropTypes.func.isRequired,
};

const CardDesignerGridControls = ({
  className,
  gridEnabled,
  setGridEnabled,
}) => {
  const classes = classNames({
    [className]: !!className,
  });

  return (
    <div className={classes}>
      <Label id="background-control">Grid Guide</Label>
      <div className="card-designer-layout-controls-grid">
        Show grid
        <Switch
          uncheckedIcon={false}
          checkedIcon={false}
          height={20}
          width={40}
          onColor="#7ace21"
          offColor="#cdd6e4"
          checked={gridEnabled}
          onChange={() => setGridEnabled(prev => !prev)}
        />
      </div>
    </div>
  );
};

CardDesignerGridControls.propTypes = propTypes;

export default CardDesignerGridControls;
